import { Box, Heading, Stack } from '@chakra-ui/react';
import { Button, Divider } from '@diamond/shared/ui';
import { useNlbRedDotIndicator } from '@diamond/sol-buyer-context';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { NlbRedDotBadge } from './NlbRedDotBadge';

export interface BuyerProfileProps {
  children: React.ReactNode;
  navigation?: React.ReactNode;
}

export function BuyerProfileLayout({
  children,
  navigation,
}: BuyerProfileProps) {
  const router = useRouter();
  const { showRedDot } = useNlbRedDotIndicator();

  return (
    <Box flex="1">
      <Heading fontSize="2xl" fontWeight="semibold">
        Akun
      </Heading>
      <Divider mt="5" borderColor="gray.33" />
      <Box overflow="auto">
        {navigation ?? (
          <Stack
            direction="row"
            spacing="4"
            py="6"
            w={{ base: 'lg', md: 'full' }}
          >
            <Link href="/profile">
              <Button
                isActive={router.pathname === '/profile'}
                _active={{
                  bg: 'rgba(0, 0, 163, 0.1)',
                  color: 'blue',
                  borderColor: 'blue',
                }}
              >
                Detail Akun
              </Button>
            </Link>
            <Link href="/profile/payment-info">
              <Box as="span" position="relative" display="inline-block">
                <Button
                  isActive={router.pathname === '/profile/payment-info'}
                  _active={{
                    bg: 'rgba(0, 0, 163, 0.1)',
                    color: 'blue',
                    borderColor: 'blue',
                  }}
                >
                  Info Pembayaran
                </Button>
                {showRedDot ? <NlbRedDotBadge top="2px" right="2px" /> : null}
              </Box>
            </Link>
            <Link href="/profile/addresses">
              <Button
                isActive={router.pathname === '/profile/addresses'}
                _active={{
                  bg: 'rgba(0, 0, 163, 0.1)',
                  color: 'blue',
                  borderColor: 'blue',
                }}
              >
                Alamat
              </Button>
            </Link>
            <Link href="/profile/password">
              <Button
                isActive={router.pathname === '/profile/password'}
                _active={{
                  bg: 'rgba(0, 0, 163, 0.1)',
                  color: 'blue',
                  borderColor: 'blue',
                }}
              >
                Ubah Kata Sandi
              </Button>
            </Link>
          </Stack>
        )}
      </Box>
      <Box minH="450px">{children}</Box>
    </Box>
  );
}

export default BuyerProfileLayout;
